<template>
  <div>
    <template v-for="(line, index) in taxes">
      <el-row>
        <el-col :span="8">
          <h6 v-if="index === 0">Tax</h6>
          <h6 v-else>&nbsp;</h6>
        </el-col>
        <el-col :span="12">
          {{ line.title }} {{ line.rate | percent }}
        </el-col>
        <el-col :span="4" class="text-right">
          <PriceDisplay
              :originalPrice="Number(line.price)"
              :updatePrice="Number(line.price)"
          />
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {
  currency,
  percent,
} from '../../../../filters';
import {rollUpTaxLines} from '../../../../utils';
import PriceDisplay from '../../Shared/PriceDisplay';

export default {
  name: 'OrderTaxes',
  components: {PriceDisplay},
  filters: {
    percent,
    currency,
  },
  computed: {
    ...mapState({
      order: state => {
        if (state.order.draftOrder) {
          return state.order.draftOrder;
        }
        return state.order.order;
      },
    }),
    taxes() {
      return rollUpTaxLines(this.order.tax_lines);
    },
  },
};
</script>
